import React from 'react';
import Slider from "./Slider";
import AboutUs from "./AboutUs";
import PracticeTable from "./PracticeTable";
import FeaturesAndInterface from "./FeaturesAndInterface";
import ContactUs from "./ContactUs";
import BaseMaster from "../BaseMaster";

function Home() {
    return (
        <BaseMaster>
            <main>
                <Slider />
                <AboutUs />
                <PracticeTable />
                <FeaturesAndInterface />
                <ContactUs />
            </main>
        </BaseMaster>
    );
}

export default Home;
